import { useDispatch } from 'react-redux';
import { CanvasPixelated } from './lib/canvas-pixelated';
import { useState, useEffect, useRef } from 'react';
import { setAnimating } from '@educaplay/store/slices/gameSlice';

export default function usePixelateCanvas(options) {
    const [pixelated, setPixelated] = useState(null);
    const canvasRef = useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!canvasRef.current) return;
        const pixelatedInstance = new CanvasPixelated(canvasRef.current, options);
        setPixelated(pixelatedInstance);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const discoverPixelated = async (options) => {
        if (pixelated) {
            dispatch(setAnimating(true)); 
            await pixelated.discover(options);
            dispatch(setAnimating(false)); 
        }
    };

    return { canvasRef, discoverPixelated };
}